import { createFileRoute, Outlet } from "@tanstack/react-router";
import { MenuPanes, useWideScreen } from "../features/menu/panes";
import { Require } from "../features/require";

type Search = { category?: string };

export const Route = createFileRoute("/menu")({
	/** The category chosen in the left pane on wide screens. */
	validateSearch: (search: Record<string, unknown>): Search =>
		typeof search.category === "string" ? { category: search.category } : {},
	component: Layout,
});

/** Phones: one screen at a time. Wide screens: three panes with the form route on the right. */
function Layout() {
	const wide = useWideScreen();
	return (
		<Require permission="menu.availability">
			{wide ? (
				<MenuPanes>
					<Outlet />
				</MenuPanes>
			) : (
				<Outlet />
			)}
		</Require>
	);
}
